/**
 * React Query cache namespace and progress-toast id prefix for this surface. Was the literal
 * `'building-attachments'` inside `queryKeys.ts`; named here because the shared surface, the field
 * commit and the bulk actions all have to agree on it.
 */
export const BUILDING_ATTACHMENTS_ENTITY_KEY = 'building-attachments';
/** Locale namespace holding this surface's table copy. */
export const BUILDING_ATTACHMENTS_NS = 'features.building_attachments.table';
export const MASS_ACTIONS_NS = 'features.building_attachments.mass_actions';
/** Note `tab`, not `table` — the toast copy is a sibling of the table namespace, not a child. */
export const PROGRESS_TOAST_NS = 'features.building_attachments.tab.progress_toast';
export const VISIBILITY_EDIT_NS = 'features.building_attachments.edit_modal.visibility';
export const EDIT_MODAL_ERRORS_NS = 'features.building_attachments.edit_modal.errors';
export const UPLOAD_NS = 'features.building_attachments.upload';
export const COMMONS_NS = 'features.commons';
export const TECHS_VALUE = 'techs';
export const PORTAL_VALUE = 'portal';
